.StatusChip {
    display: inline-block;
    padding: 5px 14px;
    border-radius: 14px;
    border: 1px solid transparent;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    white-space: nowrap;

    &.isSizeSmall {
        padding: 3px 10px;
        font-size: 10px;
    }

    &.isVariantSuccess {
        background: var(--soniq-t--global--background--color--status--success--default);
        color: var(--soniq-t--global--text--color--status--success--default);
        border-color: var(--soniq-t--global--border--color--status--success--default);
    }

    &.isVariantInfo {
        background: var(--soniq-t--global--background--color--status--info--default);
        color: var(--soniq-t--global--text--color--status--info--default);
        border-color: var(--soniq-t--global--border--color--status--info--default);
    }

    &.isVariantDanger {
        background: var(--soniq-t--global--background--color--status--danger--default);
        color: var(--soniq-t--global--text--color--status--danger--default);
        border-color: var(--soniq-t--global--border--color--status--danger--default);
    }

    &.isVariantWarning {
        background: var(--soniq-t--global--background--color--status--warning--default);
        color: var(--soniq-t--global--text--color--status--warning--default);
        border-color: var(--soniq-t--global--border--color--status--warning--default);
    }

    &.isVariantNeutral {
        background: var(--soniq-t--global--background--color--status--neutral--default);
        color: var(--soniq-t--global--text--color--status--neutral--default);
        border-color: var(--soniq-t--global--border--color--status--neutral--default);
    }

    &.isVariantMuted {
        background: var(--soniq-t--global--background--color--status--muted--default);
        color: var(--soniq-t--global--text--color--status--muted--default);
        border-color: var(--soniq-t--global--border--color--status--muted--default);
    }
}
